import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import { useSelector } from 'react-redux'; 

const BachiDealDB = () => {
  const authState = useSelector(state => state.authReducer);
  const [email, setEmail] = useState('');
  const [submitstatus, setSubmitstatus] = useState('');
  const [isError, setIsError] = useState(false);
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();

  const validateEmail = (email) => /\S+@\S+\.\S+/.test(email);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateEmail(email)) {
      setIsError(true);
      setSubmitstatus('Please enter a valid email address.');
      return;
    }

    const config = {
        url: '/newsletter',
        method: 'post',
        data: { email },
        headers: { Authorization: authState.token }
    };

    try {
      const response = await fetchData(config);
      
      if (response && response.status) {
        setSubmitstatus('Thank you for subscribing!');
        setIsError(false);
        setEmail('');
      } else {
        setIsError(true);
        setSubmitstatus('Sorry, we encountered an issue while processing your subscription.');
      }
    } catch (error) {
        if (error?.response?.status === 409) {
            setIsError(true)
          setSubmitstatus("You have already subscribed with this email.");
        } else {
        //   console.error("Error:", error);
          setIsError(true)
          setSubmitstatus("Something went wrong. Please try again later.");
        }
      }

    // Optional: navigate to a thank you page if needed
    // navigate('/newsletter-thankyou', { state: { submitstatus } });
  };

  return (
    <section id="signup" className="py-16 px-4 sm:px-6 md:px-20 bg-purple-600">
      <div className="bg-gray-100 p-8 sm:p-10 rounded-2xl max-w-3xl mx-auto text-center">
        <h3 className="text-2xl font-bold text-gray-800 mb-4">BachiDeal Recognition Database</h3>
        <p className="mb-6 text-gray-600">Input Certificate Number to Verify BachiDeal Certificate in Think5Whys DB</p>

        <form onSubmit={handleSubmit} className="flex justify-center">
          <div className="flex flex-col items-center gap-4 w-full max-w-md">
            <input
              type="email"
              placeholder="Enter BachiDeal Certificate Number"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-400"
              aria-label="Certificate Number"
            />
            <button
              type="submit"
              className="w-full px-6 py-2 bg-pink-600 text-white rounded-lg hover:bg-pink-700 transition"
            >
              Search
            </button>
          </div>
        </form>

        {submitstatus && (
          <p className={`mt-4 text-sm ${isError ? 'text-red-600' : 'text-green-600'}`}>
            {submitstatus}
          </p>
        )}
      </div>
    </section>
  );
};

export default BachiDealDB;
